var render = function render(){var _vm=this,_c=_vm._self._c;return _c('marks-tabs',{scopedSlots:_vm._u([{key:"markContent",fn:function(tabScope){return (tabScope.shouldShow)?_c('mark-tab-content',{attrs:{"module":tabScope.module,"activeModule":tabScope.activeModule}}):_vm._e()}}],null,true)},[_c('overview-tab-content',{attrs:{"slot":"overview-tab"},slot:"overview-tab"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }